import { PickList } from "primereact/picklist";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AiOutlineFolder } from "react-icons/ai";
import { FlatCardObject } from "../../../../../components/flat-card-object";
import { IObjectResponse } from "../../../../../models/IObjectResponse";
import { getAvailableItemManager } from "../../../../../services/media.service";
import { Objects } from "../../../../base/home/styles";
import { CardDescription, ObjectsCategoryIcon } from "../../../styled"
import { CustomPickList } from "./styled";

export function ItemPickListForm(props: any) {
    const { t: translation } = useTranslation();

    const { updateData = false, itemData, handleSetValue } = props;

    const [source, setSource] = useState([]);
    const [target, setTarget] = useState([]);

    const onChange = (event: any) => {
        setSource(event.source);
        setTarget(event.target);
        handleSetValue('item_medias', event.source)
    }

    useEffect(() => {
        getAvailableItemManager().then(data => {
            setTarget(data);
        })
    }, [])

    useEffect(() => {
        if (itemData && itemData.medias) {
            setSource(itemData.medias);
            handleSetValue('item_medias', itemData.medias)
        }
    }, [itemData])

    const itemTemplate = (item: any) => {
        return (
            <div className="product-details">
                {item.category && item.category.category_icon ? (<>
                    <ObjectsCategoryIcon style={{ textAlign: 'left' }} className={`material-icons-${item?.category?.category_icon}`}>{item?.category?.category_icon.split(' ')[1]}</ObjectsCategoryIcon>
                </>) : (<></>)}
                <div className="product-title" style={{ verticalAlign: 'text-bottom', marginLeft: '5px' }}>{item.title}</div>
            </div>
        );
    }

    return (
        <>
            <CardDescription>
                <CustomPickList>
                    <div className="title mb-3"><AiOutlineFolder fontSize={20} style={{ marginTop: '-5px' }}></AiOutlineFolder> {translation('material.medias')}</div>

                    {updateData ? (<>
                        <PickList source={source} target={target} itemTemplate={itemTemplate}
                            onChange={onChange} sourceHeader="Vinculados" targetHeader="Disponíveis"
                            showSourceControls={false} showTargetControls={false}
                        />
                    </>) : (<>
                        {/* <Row>
                            {!!itemData?.medias && itemData?.medias.map((arrayMedias: IObject, index: any) => {
                                return (
                                    <Col md={4}>
                                        <div key={index}>
                                            <MiniCardObject object={arrayMedias} />
                                            <FlatCardObject object={arrayMedias as IObjectResponse} detailsMode  />
                                        </div>
                                    </Col>
                                )
                            })}
                            {itemData?.medias?.length === 0 ? (
                                <h6>{translation('notFound.unity')}</h6>
                            ) : (
                                <></>
                            )}
                        </Row> */}
                        <Objects>
                            {!!itemData?.medias && itemData?.medias.map(
                                (arrayMedias: IObjectResponse, index: any) => (

                                    <div key={index}>
                                        <FlatCardObject detailsMode managerMode object={arrayMedias} />
                                    </div>

                                )
                            )}
                            {itemData?.medias?.length === 0 ? (
                                <h6>{translation('notFound.unity')}</h6>
                            ) : (
                                <></>
                            )}
                        </Objects>

                    </>)}
                </CustomPickList>
            </CardDescription>
        </>
    )
}